module.exports = __webpack_public_path__ + "img/54.87f4b35c.png";